/* eslint-disable @typescript-eslint/no-explicit-any */
import FJEventBridge from '@src/manager/FJEventBridge.ts';

export const FJEventBridgeTarget = {
    PROGRESS_MODAL: 'progress-modal',
    LOADING_MODAL: 'loading-modal',
};

class FJEventBridgeManager {
    private _bridges: FJEventBridge[];

    constructor() {
        this._bridges = [];
    }

    public getBridge(target: string) {
        const b = this._bridges.find(bridge => bridge.bridgeTarget === target);
        if (b) {
            return b;
        } else {
            const n = new FJEventBridge({ target });
            this._bridges.push(n);
            return n;
        }
    }

    public removeBridge(target: string) {
        this._bridges = this._bridges.filter(bridge => bridge.bridgeTarget !== target);
    }
}

const instance = new FJEventBridgeManager();
export default instance;
